// extracted by mini-css-extract-plugin
export var button = "_m0-2";
export var card = "_m0-0";
export var closeButtonContainer = "_m0-3";
export var iconContainer = "_m0-1";